import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import urls from '@/ws/apiUrl.js';
// import commonMethods from '@/common/commonMethods.js';
Vue.use(Vuex);
let _this = new Vue({});
export default new Vuex.Store({
    state: {
        navList: [], // 路径导航数据
        columnList: [], // 栏目目录数据
        defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png', // 默认头像
        uploadHeader: { Authorization: 'Bearer' + window.localStorage.getItem('token') }, // 上传时头部信息
        moreJumpList: [
            { "id": 1, "name": "快捷套餐" },
            { "id": 2, "name": "严选商城" },
            { "id": 3, "name": "企业应用" },
            { "id": 4, "name": "开发者" },
            { "id": 5, "name": "解决方案" },
            { "id": 6, "name": "政策扶持" },
            { "id": 7, "name": "伙伴计划" },
            { "id": 8, "name": "分类商品列表" },
            { "id": 9, "name": "服务商列表" },
            { "id": 10, "name": "课程列表" }
        ], // 更多跳转列表
        industryList: [], // 行业分类数据
    },
    mutations: {
        /**
         * @function setColumnList 设置栏目目录数据
         * @param {*} state 
         * @param { Array } res 
         */
        setColumnList(state, res) {
            state.columnList = res;
            window.sessionStorage.setItem('columnList', JSON.stringify(res));
        },
        /**
         * @function setNavData 设置路径导航数据方法
         * @param {*} state 
         * @param { object } res 
         */
        setNavData(state, res) {
            let data = res.data, flag = res.flag;
            if(data) {
                if(flag) {
                    state.navList.push(data);
                } else {
                    if(data.length > 0) {
                        state.navList = data;
                    } else {
                        state.navList = [];
                        state.navList.push(data);
                    }
                }
            } else {
                state.navList = [];
            }
            window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        },
        /**
         * @function deleteNavItem 删除最后一个路径导航项
         * @param {*} state 
         * @param {*} res 
         */
        deleteNavItem(state, res) {
            if(res) {
                state.navList.pop();
                window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
            }
        },
        /**
         * @function removeNavItem 移出点击项之后的项
         */
        removeNavItem(state, res) {
            state.navList.splice(res.index + 1, state.navList.length);
            window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        },
        /**
         * @function setIndustryList 设置行业分类数据
         * @param {*} state 
         * @param {*} res 
         */
        setIndustryList(state, res) {
            state.industryList = res;
            window.sessionStorage.setItem('industryList', JSON.stringify(res));
        }
    },
    actions: {
        /**
         * @function getColumnData 获取栏目列表数据
         * @param {*} context 
         * @param {*} payload 
         */
        getColumnData(context, payload) {
            axios.get(urls.columnList).then(res => {
                let list = res.data.result;
                context.state.columnList = list;
                window.sessionStorage.setItem('columnList', JSON.stringify(list));
            });
        },
        /**
         * @function getRoleData 获取角色列表数据
         * @param {*} context 
         * @param {*} payload 
         */
        getRoleData(context, payload) {
            axios.get(urls.roleList).then(res => {
                let list = res.data.result;
                context.state.roleList = list;
                window.sessionStorage.setItem('roleList', JSON.stringify(list));
            });
        },
        /**
         * @function getTableData 获取表格数据
         * @param {*} context 
         * @param {*} payload 
         */
        getTableData(context, payload) {
            console.log(context, payload, 111111);
            // 页面key值，表格请求url，请求所需参数
            let key = context.state.tablePageParams.page_name;
            if(payload.table_api) {
                context.state.tablePageParams.table_api = payload.table_api;
            }
            context.state.tablePageParams.table_api_params = payload.table_api_params;
            
            // 设置表格当前页，每页数据数
            context.state.tablePageParams.table_page_params.current_page = payload.table_api_params.page;
            context.state.tablePageParams.table_page_params.limit = payload.table_api_params.limit;
            // 请求数据
            console.log('context.state.tablePageParams.table_api_params', context.state.tablePageParams.table_api_params)
            axios.get(context.state.tablePageParams.table_api, {
                params: context.state.tablePageParams.table_api_params
            }).then(res => {
                console.log('tableList>>>', res);
                let result = res.data.result, data = result.data;
                // 设置表格总数
                context.state.tablePageParams.table_page_params.total = result.total;
                // 根据页面标题名称判断当前表格数据需要处理的项
                switch (key) {
                    case 'captureIssue':
                        if(data.length > 0) {
                            for(let i = 0; i < data.length; i++) {
                                let release = data[i].release;
                                if(release.length > 0) {
                                    let cup = [];
                                    for(let j = 0; j < release.length; j++) {
                                        let column = release[j].get_column.name;
                                        cup.push(column);
                                    }
                                    data[i]['releaseCloumns'] = cup.join('、');
                                }
                            }
                        }
                        break;
                    case 'originalAudit':
                    case 'originalSet':
                        if(data.length > 0) {
                            for(let i = 0; i < data.length; i++) {
                                data[i]['article_type'] = data[i].type === 'original' ? '原创' : (
                                    data[i].type === 'reprint' ? '转载' : ''
                                );
                            }
                        }
                        break;
                    case 'issueManage':
                        break;
                    default:
                        break;
                }
                // 设置表格数据
                context.state.tablePageParams.table_list = data;
                // 设置当前表格页缓存参数
                console.log('vuexparams>>>', context.state.tablePageParams);
                window.sessionStorage.setItem(key, JSON.stringify(context.state.tablePageParams));
            });
            // 设置当前页获取缓存的key值
            window.sessionStorage.setItem('pagekey', key);
        }
    },
    modules: {
    }
});


// WEBPACK FOOTER //
// ./src/vuex/store.js